import {observer} from 'mobx-react';
import React, {useCallback, useEffect} from 'react';
import {Table, Modal, ConfirmPopMessage} from '@vidazoo/ui-kit';
import {useScheduleReportsListContext} from '../context/ScheduleReportsListContext';
import ScheduleReportsTableRow from './ScheduleReportsTableRow';
import ScheduleReportsTableHeader from './ScheduleReportsTableHeader';
import theme from '../view/theme.module.scss';

export default observer(function ScheduleReportsList() {
    const {model} = useScheduleReportsListContext();
    useEffect(() => {model.resetFilter(); model.fetch();}, [model]);
    const renderRow = useCallback((itemIndex, viewportIndex, style) =>
        <ScheduleReportsTableRow key={model.maskItems[itemIndex]?._id || itemIndex}
            itemIndex={itemIndex} viewportIndex={viewportIndex} style={style}/>, [model]);
    const renderHeader = useCallback(() => <ScheduleReportsTableHeader/>, []);
    if (model.items.isLoading) return <div className={theme.message} role="status">Loading Schedule Reports<br/>Please wait...</div>;
    if (model.items.error) return <div className={theme.message} role="alert">Failed to load schedule reports. <button type="button" onClick={() => model.fetch()}>Retry</button></div>;
    return <>
        {model.actionError && <div className={theme.error} role="alert">{model.actionError}</div>}
        <Table className={theme.table} viewportHeight="80vh" itemsCount={model.maskItems.length} rowHeight={40}
            renderRow={renderRow} renderHeader={renderHeader} columnsManager={model} overscanItems={5} useStickyScrollbar/>
        <Modal external exitOnClickOutside isOpen={!!model.promptDeleteItem} onClose={() => {model.promptDeleteItem = null;}}>
            <ConfirmPopMessage red title="Delete Schedule Report?"
                text={`Are you sure you want to delete ${model.promptDeleteItem?.name || ''}?`}
                cancelText="No, Cancel" confirmText="Yes, Delete"
                onCancelClick={() => {model.promptDeleteItem = null;}} onConfirmClick={model.deleteItem}/>
        </Modal>
    </>;
});
